// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "../Components/Sidebar";
// import { Bar } from "react-chartjs-2";
// import DashboardTable from "./DashboardTable";
// import { authFetch } from "../utils/authFetch";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend
// } from "chart.js";
// import DashboardStockTable from "./DashboardStockTable";

// // Register Chart.js components
// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// function Dashboard() {
//   const navigate = useNavigate();
//   const [stats, setStats] = useState(null);
//   const [report, setReport] = useState([]);
//   const user = JSON.parse(localStorage.getItem("user"));
//   const [selectedTable, setSelectedTable] = useState("dashboard"); // default: dashboard table


//   // Fetch STATS
//   const fetchStats = async () => {
//     try {
//       const res = await authFetch(process.env.REACT_APP_BASE_URL + "dashboard/getStats", {
//         headers: {
//           Authorization: `Bearer ${user?.token}`,
//         },
//       },
//       navigate
//     );
//       const data = await res.json();
//       setStats(data); // ✅ Update state
//       console.log(data)
//     } catch (err) {
//       console.error("Error fetching stats:", err);
//     }
//   };

//   // Fetch REPORT
//   const fetchReport = async () => {
//     try {
//       const res = await authFetch(process.env.REACT_APP_BASE_URL + "dashboard/getChartReport", {
//         headers: {
//           Authorization: `Bearer ${user?.token}`,
//         },
//       },
//       navigate
//     );
//       const data = await res.json();
//       console.log(data)
//       setReport(Array.isArray(data) ? data : data.record || []); // ✅ Update state
//     } catch (err) {
//       console.error("Error fetching report:", err);
//     }
//   };

//   useEffect(() => {
//     if (!user || !user.token) {
//       navigate("/");
//       return;
//     }

//     fetchStats();
//     fetchReport();
//   }, []);

  

// const procurementData = report.map(item => parseFloat(item.totalProcurement) || 0);
// const stockData = report.map(item => parseFloat(item.totalStock) || 0);
// const labels = report.map(item => item.vendorName || "Unknown Vendor");

// // Clamp Y-axis max if there's an outlier
// const allValues = [...procurementData, ...stockData];
// const sortedValues = [...allValues].sort((a, b) => b - a);
// const secondLargest = sortedValues[1] || sortedValues[0]; // fallback to largest if only one vendor
// const maxYAxis = secondLargest * 1.5 || 100000; // buffer by 50%, fallback to 100000

// const chartData = {
//   labels,
//   datasets: [
//     {
//       label: "Total Procurement",
//       data: procurementData,
//       backgroundColor: "rgba(255, 99, 132, 0.6)", // Red
//       borderWidth: 1,
//     },
//     {
//       label: "Total Stock",
//       data: stockData,
//       backgroundColor: "rgba(54, 162, 235, 0.6)", // Blue
//       borderWidth: 1,
//     },
//   ],
// };

// const chartOptions = {
//   responsive: true,
//   plugins: {
//     legend: {
//       position: "top",
//     },
//     tooltip: {
//       mode: "index",
//       intersect: false,
//     },
//   },
//   scales: {
//     y: {
//       beginAtZero: true,
//       max: maxYAxis,
//       title: {
//         display: true,
//         text: "Quantity (Qtl)",
//       },
//     },
//     x: {
//       ticks: {
//         autoSkip: false,
//       },
//     },
//   },
// };

//   return (
//     <div className="flex flex-col md:flex-row min-h-screen font-sans relative">
//       <Sidebar />

//       <div className="flex-1 bg-gray-100 p-4 sm:p-6 md:ml-64 transition-all duration-300">
//         <h2 className="text-xl sm:text-2xl font-bold mb-4 sm:mb-6">Dashboard Overview</h2>

//         {/* Stats Section */}
//         {stats ? (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
//             <div className="bg-cyan-200 p-4 rounded shadow text-center">
//               <h3 className="font-semibold text-base">Total Procurement</h3>
//               <p className="text-lg">{stats.totalProcurement || 0}Qtl</p>
//             </div>
//             <div className="bg-pink-200 p-4 rounded shadow text-center">
//               <h3 className="font-semibold text-base">Total Stock</h3>
//               <p className="text-lg">{stats.totalStock?.totalStock || 0}Qtl</p>
//             </div>
//             <div className="bg-lime-200 p-4 rounded shadow text-center">
//               <h3 className="font-semibold text-base">Total Vendors</h3>
//               <p className="text-lg">{stats.vendorCount || 0}</p>
//             </div>
//           </div>
//         ) : (
//           <p>Loading stats...</p>
//         )}

//         {/* Chart Section */}
//         <div className="bg-white p-4 sm:p-6 rounded shadow mb-6">
//           <h3 className="text-lg font-semibold mb-4">Stock vs Procurement Chart</h3>
//           {report.length > 0 ? (
//             <Bar data={chartData} options={chartOptions} />
//           ) : (
//             <p>No report data available.</p>
//           )}
//         </div>

//         {/* Table Section */}
//         {/* <div className="bg-white p-4 sm:p-6 rounded shadow">
//           <h3 className="text-lg font-semibold mb-4">Report Table</h3>
//           {report.length > 0 ? (
//             <DashboardTable report={report} />
//           ) : (
//             <p>No report data available.</p>
//           )}
//         </div>

//         <div className="bg-white p-4 sm:p-6 rounded shadow">
//           <h3 className="text-lg font-semibold mb-4">Report Table</h3>
//           {report.length > 0 ? (
//             <DashboardStockTable report={report} />
//           ) : (
//             <p>No report data available.</p>
//           )}
//         </div> */}
//         <div className="bg-white p-4 sm:p-6 rounded shadow">
//   <div className="flex gap-2 mb-4">
//     <button
//       className={`px-4 py-2 rounded ${selectedTable === "dashboard" ? "bg-blue-500 text-white" : "bg-gray-200"}`}
//       onClick={() => setSelectedTable("dashboard")}
//     >
//       Procurement Table
//     </button>
//     <button
//       className={`px-4 py-2 rounded ${selectedTable === "stock" ? "bg-blue-500 text-white" : "bg-gray-200"}`}
//       onClick={() => setSelectedTable("stock")}
//     >
//       Stock Table
//     </button>
//   </div>

//   {report.length > 0 ? (
//     selectedTable === "dashboard" ? (
//       <DashboardTable report={report} />
//     ) : (
//       <DashboardStockTable report={report} />
//     )
//   ) : (
//     <p>No report data available.</p>
//   )}
// </div>

//       </div>
//     </div>
//   );
// }

// export default Dashboard;


// import React, { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import Sidebar from "../Components/Sidebar";
// import DashboardTable from "./DashboardTable";
// import DashboardStockTable from "./DashboardStockTable";
// import { Bar } from "react-chartjs-2";
// import {
//   Chart as ChartJS,
//   CategoryScale,
//   LinearScale,
//   BarElement,
//   Title,
//   Tooltip,
//   Legend,
// } from "chart.js";

// ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

// function Dashboard() {
//   const navigate = useNavigate();
//   const user = JSON.parse(localStorage.getItem("user"));

//   const [report, setReport] = useState([]);
//   const [stats, setStats] = useState(null);
//   const [sidebarOpen, setSidebarOpen] = useState(false);
//   const [selectedTable, setSelectedTable] = useState("dashboard");

//   useEffect(() => {
//     if (!user || !user.token) {
//       navigate("/");
//     } else {
//       fetchStats();
//       fetchReport();
//     }
//   }, []);

//   const fetchStats = async () => {
//     try {
//       const res = await fetch(`${process.env.REACT_APP_BASE_URL}dashboard/getStats`, {
//         headers: {
//           Authorization: `Bearer ${user?.token}`,
//         },
//       });
//       const data = await res.json();
//       setStats(data);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const fetchReport = async () => {
//     try {
//       const res = await fetch(`${process.env.REACT_APP_BASE_URL}dashboard/getChartReport`, {
//         headers: {
//           Authorization: `Bearer ${user?.token}`,
//         },
//       });
//       const data = await res.json();
//       setReport(Array.isArray(data) ? data : data.record || []);
//     } catch (err) {
//       console.error(err);
//     }
//   };

//   const labels = report.map((item) => item.vendorName || "Unknown Vendor");
//   const procurementData = report.map((item) => parseFloat(item.totalProcurement) || 0);
//   const stockData = report.map((item) => parseFloat(item.totalStock) || 0);

//   const chartData = {
//     labels,
//     datasets: [
//       {
//         label: "Total Procurement",
//         data: procurementData,
//         backgroundColor: "rgba(255, 99, 132, 0.6)",
//       },
//       {
//         label: "Total Stock",
//         data: stockData,
//         backgroundColor: "rgba(54, 162, 235, 0.6)",
//       },
//     ],
//   };

//   const chartOptions = {
//     responsive: true,
//     plugins: {
//       legend: { position: "top" },
//     },
//     scales: {
//       y: {
//         beginAtZero: true,
//         title: {
//           display: true,
//           text: "Quantity (Qtl)",
//         },
//       },
//     },
//   };

//   return (
//     <div className="flex flex-col md:flex-row min-h-screen bg-gray-100 relative">
//       {/* Sidebar */}
//       <div className={`${sidebarOpen ? "block" : "hidden"} md:block`}>
//         <Sidebar />
//       </div>

//       {/* Toggle Button for mobile */}
//       <button
//         className="fixed top-4 left-4 z-50 bg-blue-600 text-white px-4 py-2 rounded shadow-md md:hidden"
//         onClick={() => setSidebarOpen(!sidebarOpen)}
//       >
//         {sidebarOpen ? "Close Menu" : "Open Menu"}
//       </button>

//       {/* Main Content */}
//       <div className="flex-1 p-4 md:ml-64 transition-all duration-300">
//         <h2 className="text-2xl font-bold mb-4">Dashboard Overview</h2>

//         {/* Stats */}
//         {stats && (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
//             <div className="bg-cyan-200 p-4 rounded shadow text-center">
//               <h3 className="font-semibold text-base">Total Procurement</h3>
//               <p className="text-lg">{stats.totalProcurement || 0} Qtl</p>
//             </div>
//             <div className="bg-pink-200 p-4 rounded shadow text-center">
//               <h3 className="font-semibold text-base">Total Stock</h3>
//               <p className="text-lg">{stats.totalStock?.totalStock || 0} Qtl</p>
//             </div>
//             <div className="bg-lime-200 p-4 rounded shadow text-center">
//               <h3 className="font-semibold text-base">Total Vendors</h3>
//               <p className="text-lg">{stats.vendorCount || 0}</p>
//             </div>
//           </div>
//         )}

//         {/* Chart */}
//         <div className="bg-white p-4 rounded shadow mb-6">
//           <h3 className="text-lg font-semibold mb-4">Stock vs Procurement Chart</h3>
//           {report.length > 0 ? (
//             <Bar data={chartData} options={chartOptions} />
//           ) : (
//             <p>No report data available.</p>
//           )}
//         </div>

//         {/* Table Toggle */}
//         <div className="bg-white p-4 rounded shadow">
//           <div className="flex gap-2 mb-4">
//             <button
//               className={`px-4 py-2 rounded ${selectedTable === "dashboard" ? "bg-blue-500 text-white" : "bg-gray-200"}`}
//               onClick={() => setSelectedTable("dashboard")}
//             >
//               Procurement Table
//             </button>
//             <button
//               className={`px-4 py-2 rounded ${selectedTable === "stock" ? "bg-blue-500 text-white" : "bg-gray-200"}`}
//               onClick={() => setSelectedTable("stock")}
//             >
//               Stock Table
//             </button>
//           </div>

//           {report.length > 0 ? (
//             selectedTable === "dashboard" ? (
//               <DashboardTable report={report} />
//             ) : (
//               <DashboardStockTable report={report} />
//             )
//           ) : (
//             <p>No report data available.</p>
//           )}
//         </div>
//       </div>
//     </div>
//   );
// }

// export default Dashboard;


import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Sidebar from "../Components/Sidebar";
import DashboardTable from "./DashboardTable";
import DashboardStockTable from "./DashboardStockTable";
import { Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

function Dashboard() {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const [report, setReport] = useState([]);
  const [stats, setStats] = useState(null);
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedTable, setSelectedTable] = useState("dashboard");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    if (!user || !user.token) {
      navigate("/");
    } else {
      fetchStats();
      fetchReport();
    }
  }, []);
  useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 768);
  };
  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

  const fetchStats = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}dashboard/getStats`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
      const data = await res.json();
      setStats(data);
    } catch (err) {
      console.error(err);
    }
  };

  const fetchReport = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL}dashboard/getChartReport`, {
        headers: {
          Authorization: `Bearer ${user?.token}`,
        },
      });
      const data = await res.json();
      setReport(Array.isArray(data) ? data : data.record || []);
    } catch (err) {
      console.error(err);
    }
  };

  const labels = report.map((item) => item.vendorName || "Unknown Vendor");
  const procurementData = report.map((item) => parseFloat(item.totalProcurement) || 0);
  const stockData = report.map((item) => parseFloat(item.totalStock) || 0);

  const chartData = {
    labels,
    datasets: [
      {
        label: "Total Procurement",
        data: procurementData,
        backgroundColor: "rgba(255, 99, 132, 0.6)",
      },
      {
        label: "Total Stock",
        data: stockData,
        backgroundColor: "rgba(54, 162, 235, 0.6)",
      },
    ],
  };

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { position: "top" },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: "Quantity (Qtl)",
        },
      },
    },
  };

  // return (
//     <div className="flex flex-col md:flex-row min-h-screen bg-gray-100 relative">
//       {/* Sidebar */}
//       {/* Sidebar */}
// <div
//   className={`
//     fixed top-0 left-0 z-40 h-full w-64 bg-white shadow-md 
//     transform transition-transform duration-300 ease-in-out
//     ${sidebarOpen ? "translate-x-0" : "-translate-x-full"}
//     md:translate-x-0
//   `}
// >
//   <Sidebar />
// </div>


//       {/* Toggle Button */}
//       {/* Toggle Button - always visible */}
// <button
//   className="fixed top-4 left-4 z-50 bg-blue-600 text-white px-4 py-2 rounded shadow md:z-10"
//   onClick={() => setSidebarOpen(!sidebarOpen)}
// >
//   {sidebarOpen ? "Close Menu" : "Open Menu"}
// </button>


//       {/* Main Content */}
//       <div
//   className={`flex-1 p-4 transition-all duration-300 ${
//     !isMobile ? "md:ml-64" : ""
//   }`}
// >
//         <h2 className="text-2xl font-bold mb-4">Dashboard Overview</h2>

//         {/* Stats */}
//         {stats && (
//           <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
//             <div className="bg-cyan-200 p-4 rounded shadow text-center">
//               <h3 className="font-semibold text-base">Total Procurement</h3>
//               <p className="text-lg">{stats.totalProcurement || 0} Qtl</p>
//             </div>
//             <div className="bg-pink-200 p-4 rounded shadow text-center">
//               <h3 className="font-semibold text-base">Total Stock</h3>
//               <p className="text-lg">{stats.totalStock?.totalStock || 0} Qtl</p>
//             </div>
//             <div className="bg-lime-200 p-4 rounded shadow text-center">
//               <h3 className="font-semibold text-base">Total Vendors</h3>
//               <p className="text-lg">{stats.vendorCount || 0}</p>
//             </div>
//           </div>
//         )}

//         {/* Chart */}
//         <div className="bg-white p-4 rounded shadow mb-6">
//           <h3 className="text-lg font-semibold mb-4">Stock vs Procurement Chart</h3>
//           {report.length > 0 ? (
//             <Bar data={chartData} options={chartOptions} />
//           ) : (
//             <p>No report data available.</p>
//           )}
//         </div>

//         {/* Table Toggle */}
//         <div className="bg-white p-4 rounded shadow">
//           <div className="flex gap-2 mb-4">
//             <button
//               className={`px-4 py-2 rounded ${
//                 selectedTable === "dashboard" ? "bg-blue-500 text-white" : "bg-gray-200"
//               }`}
//               onClick={() => setSelectedTable("dashboard")}
//             >
//               Procurement Table
//             </button>
//             <button
//               className={`px-4 py-2 rounded ${
//                 selectedTable === "stock" ? "bg-blue-500 text-white" : "bg-gray-200"
//               }`}
//               onClick={() => setSelectedTable("stock")}
//             >
//               Stock Table
//             </button>
//           </div>

//           {report.length > 0 ? (
//             selectedTable === "dashboard" ? (
//               <DashboardTable report={report} />
//             ) : (
//               <DashboardStockTable report={report} />
//             )
//           ) : (
//             <p>No report data available.</p>
//           )}
//         </div>
//       </div>
//     </div>

return (
    <div>
      <h2 className="text-2xl mt-8 font-bold mb-4">Dashboard Overview</h2>

      {stats && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
          <div className="bg-cyan-200 p-4 rounded shadow text-center">
            <h3 className="font-semibold text-base">Total Procurement</h3>
            <p className="text-lg">{stats.totalProcurement || 0} Qtl</p>
          </div>
          <div className="bg-pink-200 p-4 rounded shadow text-center">
            <h3 className="font-semibold text-base">Total Stock</h3>
            <p className="text-lg">{stats.totalStock?.totalStock || 0} Qtl</p>
          </div>
          <div className="bg-lime-200 p-4 rounded shadow text-center">
            <h3 className="font-semibold text-base">Total Vendors</h3>
            <p className="text-lg">{stats.vendorCount || 0}</p>
          </div>
        </div>
      )}

      <div className="bg-white p-4 rounded shadow mb-6">
        <h3 className="text-lg font-semibold mb-4">Stock vs Procurement Chart</h3>
        {report.length > 0 ? (
          <Bar data={chartData} options={chartOptions} />
        ) : (
          <p>No report data available.</p>
        )}
      </div>

      <div className="bg-white p-4 rounded shadow">
        <div className="flex gap-2 mb-4">
          <button
            className={`px-4 py-2 rounded ${
              selectedTable === "dashboard" ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
            onClick={() => setSelectedTable("dashboard")}
          >
            Procurement Table
          </button>
          <button
            className={`px-4 py-2 rounded ${
              selectedTable === "stock" ? "bg-blue-500 text-white" : "bg-gray-200"
            }`}
            onClick={() => setSelectedTable("stock")}
          >
            Stock Table
          </button>
        </div>

        {report.length > 0 ? (
          selectedTable === "dashboard" ? (
            <DashboardTable report={report} />
          ) : (
            <DashboardStockTable report={report} />
          )
        ) : (
          <p>No report data available.</p>
        )}
      </div>
    </div>
  );
}

export default Dashboard;